export const UPDATE_STATS_COMPLETE = "UPDATE_STATS_COMPLETE";
export const CREATE_STATS_COMPLETE = "CREATE_STATS_COMPLETE";
export const FINISH_PERIOD_COMPLETE = "FINISH_PERIOD_COMPLETE";
export const GET_STATS_COMPLETE = "GET_STATS_COMPLETE";
export const DELETE_STATS_COMPLETE = "DELETE_STATS_COMPLETE";
export const PLAY_COMPLETE = "PLAY_COMPLETE";
export const PAUSE_COMPLETE = "PAUSE_COMPLETE";
export const START_PERIOD_COMPLETE = "START_PERIOD_COMPLETE";
export const SET_TIME_COMPLETE = "SET_TIME_COMPLETE";
export const FINALIZE_GAME_COMPLETE = "FINALIZE_GAME_COMPLETE";
export const SAVE_FINALIZATION_SETTINGS_COMPLETE =
	"SAVE_FINALIZATION_SETTINGS_COMPLETE";
export const SET_TIME_AND_PERIOD = "SET_TIME_AND_PERIOD";
export const SET_TIME_AND_PERIOD_COMPLETE = "SET_TIME_AND_PERIOD_COMPLETE";
export const SET_TIME_AND_PERIOD_ERROR = "SET_TIME_AND_PERIOD_ERROR";
export const SHOW_TIME_CONFIG = "SHOW_TIME_CONFIG";
export const VALIDATE_GAME_DATA = "VALIDATE_GAME_DATA";
export const VALIDATE_GAME_DATA_COMPLETE = "VALIDATE_GAME_DATA_COMPLETE";
export const SET_OVERTIME_NOTIFICATION = "SET_OVERTIME_NOTIFICATION";
export const SET_OVERTIME_NOTIFICATION_COMPLETE =
	"SET_OVERTIME_NOTIFICATION_COMPLETE";
export const SWAP_TEAMS = "SWAP_TEAMS";
export const SWAP_TEAMS_COMPLETE = "SWAP_TEAMS_COMPLETE";
export const KEEP_SWAPPING_TEAMS = "KEEP_SWAPPING_TEAMS";
export const KEEP_SWAPPING_TEAMS_COMPLETE = "KEEP_SWAPPING_TEAMS_COMPLETE";
export const CONFIRM_PERIOD_NOTIFICATION = "CONFIRM_PERIOD_NOTIFICATION";
export const CONFIRM_PERIOD_NOTIFICATION_COMPLETE =
	"CONFIRM_PERIOD_NOTIFICATION_COMPLETE";
export const SAVE_MATCHES_FINALIZATION_ORDER =
	"SAVE_MATCHES_FINALIZATION_ORDER";
export const SAVE_MATCHES_FINALIZATION_ORDER_COMPLETE =
	"SAVE_MATCHES_FINALIZATION_ORDER_COMPLETE";
export const ORDER_PLAYERS_BY_POSITION = "ORDER_PLAYERS_BY_POSITION";
export const ORDER_PLAYERS_BY_POSITION_COMPLETE =
	"ORDER_PLAYERS_BY_POSITION_COMPLETE";
export const GET_PROMPT_RECEIVING_TEAM_COMPLETE =
	"GET_PROMPT_RECEIVING_TEAM_COMPLETE";
export const UPDATE_RECEIVING_TEAM_COMPLETE = "UPDATE_RECEIVING_TEAM_COMPLETE";
